import { getCountry } from '@iwIntlProvider/CountryProvider';

export class Constants {
    static get MIN_DRAW_DOWN_AMOUNT() {
        return this._getCountryConstant('minDrawdownAmount');
    }

    static get MIN_LOAN_AMOUNT() {
        return this._getCountryConstant('minLoanAmount');
    }

    static get MAX_LOAN_AMOUNT() {
        return this._getCountryConstant('maxLoanAmount');
    }

    static get PHONE_NUMBER() {
        return this._getCountryConstant('phoneNumber');
    }
    static get EMAIL() {
        return this._getCountryConstant('email');
    }

    static _getCountryConstant<T extends keyof TCountryConstants>(
        key: T
    ): TCountryConstants[T] {
        return getCountry() === 'DE' ? deConstants[key] : ukConstants[key];
    }
}

type TCountryConstants = typeof ukConstants | typeof deConstants;

const ukConstants = {
    minDrawdownAmount: 100,
    minLoanAmount: 1_000,
    maxLoanAmount: 1_000_000,
    phoneNumber: {
        display: '020 3778 0274',
        tel: 'tel:+44-20-3778-0274'
    },
    email: 'support@iwoca.co.uk'
} as const;

const deConstants = {
    minDrawdownAmount: 150,
    minLoanAmount: 1_000,
    maxLoanAmount: 500_000,
    phoneNumber: {
        display: '069 9432 3020',
        tel: 'tel:+49-69-9432-3020'
    },
    email: 'support@iwoca.de'
} as const;
